"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alias", {
  enumerable: true,
  get: function get() {
    return _alias.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "calc", {
  enumerable: true,
  get: function get() {
    return _calc.default;
  }
});
Object.defineProperty(exports, "car", {
  enumerable: true,
  get: function get() {
    return _car.default;
  }
});
Object.defineProperty(exports, "cdr", {
  enumerable: true,
  get: function get() {
    return _cdr.default;
  }
});
Object.defineProperty(exports, "choose", {
  enumerable: true,
  get: function get() {
    return _choose.default;
  }
});
Object.defineProperty(exports, "echo", {
  enumerable: true,
  get: function get() {
    return _echo.default;
  }
});
Object.defineProperty(exports, "equal", {
  enumerable: true,
  get: function get() {
    return _equal.default;
  }
});
Object.defineProperty(exports, "exec", {
  enumerable: true,
  get: function get() {
    return _exec.default;
  }
});
Object.defineProperty(exports, "falseCommand", {
  enumerable: true,
  get: function get() {
    return _false.default;
  }
});
Object.defineProperty(exports, "fg", {
  enumerable: true,
  get: function get() {
    return _fg.default;
  }
});
Object.defineProperty(exports, "flatten", {
  enumerable: true,
  get: function get() {
    return _flatten.default;
  }
});
Object.defineProperty(exports, "get", {
  enumerable: true,
  get: function get() {
    return _get.default;
  }
});
Object.defineProperty(exports, "greaterThan", {
  enumerable: true,
  get: function get() {
    return _greaterThan.default;
  }
});
Object.defineProperty(exports, "head", {
  enumerable: true,
  get: function get() {
    return _head.default;
  }
});
Object.defineProperty(exports, "help", {
  enumerable: true,
  get: function get() {
    return _help.default;
  }
});
Object.defineProperty(exports, "ifCommand", {
  enumerable: true,
  get: function get() {
    return _if.default;
  }
});
Object.defineProperty(exports, "jobs", {
  enumerable: true,
  get: function get() {
    return _jobs.default;
  }
});
Object.defineProperty(exports, "join", {
  enumerable: true,
  get: function get() {
    return _join.default;
  }
});
Object.defineProperty(exports, "kill", {
  enumerable: true,
  get: function get() {
    return _kill.default;
  }
});
Object.defineProperty(exports, "length", {
  enumerable: true,
  get: function get() {
    return _length.default;
  }
});
Object.defineProperty(exports, "lessThan", {
  enumerable: true,
  get: function get() {
    return _lessThan.default;
  }
});
Object.defineProperty(exports, "list", {
  enumerable: true,
  get: function get() {
    return _list.default;
  }
});
Object.defineProperty(exports, "noFormat", {
  enumerable: true,
  get: function get() {
    return _noFormat.default;
  }
});
Object.defineProperty(exports, "noop", {
  enumerable: true,
  get: function get() {
    return _noop.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "promote", {
  enumerable: true,
  get: function get() {
    return _promote.default;
  }
});
Object.defineProperty(exports, "range", {
  enumerable: true,
  get: function get() {
    return _range.default;
  }
});
Object.defineProperty(exports, "repeat", {
  enumerable: true,
  get: function get() {
    return _repeat.default;
  }
});
Object.defineProperty(exports, "sleep", {
  enumerable: true,
  get: function get() {
    return _sleep.default;
  }
});
Object.defineProperty(exports, "split", {
  enumerable: true,
  get: function get() {
    return _split.default;
  }
});
Object.defineProperty(exports, "tail", {
  enumerable: true,
  get: function get() {
    return _tail.default;
  }
});
Object.defineProperty(exports, "trueCommand", {
  enumerable: true,
  get: function get() {
    return _true.default;
  }
});
Object.defineProperty(exports, "whoami", {
  enumerable: true,
  get: function get() {
    return _whoami.default;
  }
});
Object.defineProperty(exports, "xargs", {
  enumerable: true,
  get: function get() {
    return _xargs.default;
  }
});
exports.default = void 0;

require("source-map-support/register");

var _alias = _interopRequireDefault(require("./alias"));

var _and = _interopRequireDefault(require("./and"));

var _calc = _interopRequireDefault(require("./calc"));

var _car = _interopRequireDefault(require("./car"));

var _cdr = _interopRequireDefault(require("./cdr"));

var _choose = _interopRequireDefault(require("./choose"));

var _echo = _interopRequireDefault(require("./echo"));

var _equal = _interopRequireDefault(require("./equal"));

var _exec = _interopRequireDefault(require("./exec"));

var _false = _interopRequireDefault(require("./false"));

var _fg = _interopRequireDefault(require("./fg"));

var _flatten = _interopRequireDefault(require("./flatten"));

var _get = _interopRequireDefault(require("./get"));

var _greaterThan = _interopRequireDefault(require("./greaterThan"));

var _head = _interopRequireDefault(require("./head"));

var _help = _interopRequireDefault(require("./help"));

var _if = _interopRequireDefault(require("./if"));

var _jobs = _interopRequireDefault(require("./jobs"));

var _join = _interopRequireDefault(require("./join"));

var _kill = _interopRequireDefault(require("./kill"));

var _length = _interopRequireDefault(require("./length"));

var _lessThan = _interopRequireDefault(require("./lessThan"));

var _list = _interopRequireDefault(require("./list"));

var _noFormat = _interopRequireDefault(require("./noFormat"));

var _noop = _interopRequireDefault(require("./noop"));

var _not = _interopRequireDefault(require("./not"));

var _or = _interopRequireDefault(require("./or"));

var _promote = _interopRequireDefault(require("./promote"));

var _range = _interopRequireDefault(require("./range"));

var _repeat = _interopRequireDefault(require("./repeat"));

var _sleep = _interopRequireDefault(require("./sleep"));

var _split = _interopRequireDefault(require("./split"));

var _tail = _interopRequireDefault(require("./tail"));

var _true = _interopRequireDefault(require("./true"));

var _whoami = _interopRequireDefault(require("./whoami"));

var _xargs = _interopRequireDefault(require("./xargs"));

var _default = [_alias.default, _and.default, _calc.default, _car.default, _cdr.default, _choose.default, _echo.default, _equal.default, _exec.default, _false.default, _fg.default, _flatten.default, _get.default, _greaterThan.default, _head.default, _help.default, _if.default, _jobs.default, _join.default, _kill.default, _length.default, _lessThan.default, _list.default, _noFormat.default, _noop.default, _not.default, _or.default, _promote.default, _range.default, _repeat.default, _sleep.default, _split.default, _tail.default, _true.default, _whoami.default, _xargs.default];
exports.default = _default;